module.exports = __webpack_public_path__ + "static/media/468x60_0045_ro.3c9cc26e.jpg";